module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', [_c('div', {
    staticClass: "holder"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_vm._v("© 2019")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "btn-appeal btn",
    attrs: {
      "href": _vm.props.authorizedUser == null ? _vm.getEsiaUrl() : '/appeal'
    }
  }, [_c('span', [_vm._v("Подать обращение")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/policy",
      "id": "policy"
    }
  }, [_vm._v("Политика обработки персональных данных")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "id": "browsers-support"
    },
    on: {
      "click": function($event) {
        return _vm.$('#browsers-support')
      }
    }
  }, [_vm._v("Список поддерживаемых браузеров")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-fadeout"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper",
    attrs: {
      "id": "modal-geo"
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "modal-close",
    attrs: {
      "title": "Close"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Выбрать муниципальное образование")]), _vm._v(" "), _c('select', {
    attrs: {
      "id": "mun_select",
      "name": "geo"
    }
  }, _vm._l((_vm.props.municipalities), function(municipality) {
    return (municipality.id != _vm.constants.MUNICIPALITIES.ALL) ? _c('option', {
      attrs: {
        "name": municipality.name
      },
      domProps: {
        "value": municipality.id,
        "selected": municipality.id == _vm.props.municipalityId
      }
    }, [_vm._v(_vm._s(municipality.name))]) : _vm._e()
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn type2",
    on: {
      "click": function($event) {
        return _vm.saveMunicipality()
      }
    }
  }, [_vm._v("Сохранить")])])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#",
      "id": "logo-footer"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo.png"),
      "alt": "Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»",
      "title": "Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-wrapper",
    attrs: {
      "id": "modal-browsers-support"
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "modal-close",
    attrs: {
      "title": "Close"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Список поддерживаемых браузеров")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Microsoft Edge / Internet Explorer 10 и выше")]), _vm._v(" "), _c('li', [_vm._v("Mozilla Firefox 60 и выше")]), _vm._v(" "), _c('li', [_vm._v("Google Chrome 49 и выше")]), _vm._v(" "), _c('li', [_vm._v("Opera 35 и выше")]), _vm._v(" "), _c('li', [_vm._v("iOS Safari 12 и выше")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e5ba9c9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VFooter.vue
// module id = 13
// module chunks = 1 2 3 4 5 6 7 8